import { IAPIRoutes } from "../../../../config";

export type IUserRepository = ReturnType<typeof UserRepositoryFactory>;

export const UserRepositoryFactory = ({
  APIProvider,
  AuthService,
  APIRoutes,
}: {
  APIProvider: IAPIProvider;
  AuthService: IAuthService;
  APIRoutes: IAPIRoutes;
}) => {
  const { GET, PUT, POST } = APIProvider;
  const { getAuthenticationToken } = AuthService;

  const getUserBetaFeatures: IGetUserBetaFeaturesAPI = async () =>
    GET(
      APIRoutes.apiUserBetaFeature,
      {},
      {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
      }
    );

  const getPortalUserInfo: IGetPortalUserInfoAPI = async () =>
    GET(
      APIRoutes.apiGetPortalUserInfo,
      {},
      {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
      }
    );

  const updateUserInfo: IUpdateUserInfoAPI = async (payload) =>
    PUT(APIRoutes.apiUpdateUserInfo, payload, {
      Authorization: `Bearer ${await getAuthenticationToken()}`,
    });

  const signupUser: ISignupUserAPI = async (payload) =>
    POST(APIRoutes.apiSignup, payload, {});

  const autoBedExit: IAutoBedExitAPI = async (payload) =>
    POST(APIRoutes.apiAutoBedExit, payload, {
      Authorization: `Bearer ${await getAuthenticationToken()}`,
    });

  const getNasaTlxPreference: IGetNasaTlxPreferenceAPI = async () =>
    GET(
      APIRoutes.apiNasaTlxPreference,
      {},
      {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
      }
    );

  const submitNasaTlxPreference: ISubmitNasaTlxPreferenceAPI = async (
    payload
  ) =>
    POST(APIRoutes.apiNasaTlxPreference, payload, {
      Authorization: `Bearer ${await getAuthenticationToken()}`,
      "Content-Type": "application/json",
    });

  return {
    getUserBetaFeatures,
    getPortalUserInfo,
    updateUserInfo,
    signupUser,
    autoBedExit,
    getNasaTlxPreference,
    submitNasaTlxPreference,
  };
};
